export const TeamListing = (() => {
	'use strict';

	function init() {
		/*
		Red: ff5500
		Pink: fcb4b4
		Mid-Green: bab83d
		Bright Green: ebeb00
		Blue: 2967f6
		Light Blue: 71dff6
		Purple: 9c4ae5
		Lavender: df8eed
		*/
		var colors = [
			'blue',
			'pink',
			'red',
			'mid-green',
			'bright-green',
			'light-blue',
			'purple',
			'lavender'
		];

		$('.team-member__photo').on('mouseenter', function() {
			var random_color = colors[Math.floor(Math.random()*colors.length)];
			var random_stroke = Math.floor(Math.random()*4) + 1;
			$(this).attr('data-active-color', random_color);
			$(this).attr('data-active-stroke', random_stroke);
		});

		$('.squiggle path').each( function() {
			var lineLength = $(this)[0].getTotalLength();
			$(this).css("stroke-dasharray", lineLength);
			$(this).css("stroke-dashoffset", lineLength);
		});
	}

	return {
		init: init,
		name: 'team-listing'
	};
})();
